var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightalarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rightalarm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 3,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,26H18A16.071,16.071,0,1,0,33.476,38H55Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 2,
    x2: 32,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.971,
    y1: 9.029,
    x2: 43.314,
    y2: 14.686
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.029,
    y1: 9.029,
    x2: 20.686,
    y2: 14.686
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 42,
    r: 6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightalarm);
export default __webpack_public_path__ + "static/media/rightalarm.f6e3abbc989bc244fb34f3de4e6c4e0d.svg";
export { ForwardRef as ReactComponent };